import { useSeo } from "@/hooks/useSeo";
import { PageHero } from "@/components/PageHero";
import { CTASection } from "@/components/CTASection";
import { Reveal } from "@/components/Reveal";

// Shared layout for institutional / legal / help text pages.
// `sections` = array of { heading, paragraphs: string[] , list?: string[] }
export const LegalContentPage = ({
  overline,
  title,
  subtitle,
  seoTitle,
  seoDescription,
  intro,
  sections = [],
  note,
  ctaTitle,
  ctaText,
  waMessage,
  updated,
}) => {
  useSeo({ title: seoTitle, description: seoDescription });
  return (
    <>
      <PageHero overline={overline} title={title} subtitle={subtitle} />
      <section className="px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl">
          {updated && <p className="mb-6 text-sm text-ink-soft">Última atualização: {updated}</p>}
          {intro && <p className="text-lg leading-relaxed text-ink-soft">{intro}</p>}

          <div className="mt-10 space-y-10">
            {sections.map((s, i) => (
              <Reveal key={i} delay={i * 0.04}>
                <div>
                  {s.heading && (
                    <h2 className="font-heading text-2xl font-semibold tracking-tight text-ink">{s.heading}</h2>
                  )}
                  {s.paragraphs?.map((p, pi) => (
                    <p key={pi} className="mt-4 text-base leading-relaxed text-ink-soft">{p}</p>
                  ))}
                  {s.list && (
                    <ul className="mt-4 space-y-2">
                      {s.list.map((li, li2) => (
                        <li key={li2} className="flex gap-3 text-base leading-relaxed text-ink-soft">
                          <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-brand" />
                          <span>{li}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </Reveal>
            ))}
          </div>

          {note && (
            <div className="mt-12 rounded-3xl border border-brand-light bg-brand-light/60 p-6">
              <p className="text-sm leading-relaxed text-ink-soft">{note}</p>
            </div>
          )}
        </div>
      </section>
      <CTASection title={ctaTitle} text={ctaText} waMessage={waMessage} />
    </>
  );
};
